export const report = (dataLayerItem) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerItem);
}

export const reportBuilder = {
    saleTransaction: (transactionInfo) => {
        const totalPrice = transactionInfo.totalPrice + transactionInfo.totalPriceOneTime;

        return {
            event: 'transaction',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: transactionInfo.transactionId,
                        revenue: totalPrice
                    },
                    products: getSaleTransactionProducts(transactionInfo.saleType, transactionInfo.selectedProducts, transactionInfo.vasList, transactionInfo.offerInfo)
                }
            }
        }
    },
}

export const reportBuilderPurchaseAbroadPackage = {
    saleTransaction: (transactionInfo) => {

        return {
            event: 'transaction',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: transactionInfo.transactionId,
                        revenue: transactionInfo?.revenue
                    },
                    products: getSaleTransactionAbroadPackage(transactionInfo.name, transactionInfo.id, transactionInfo.price)
                }
            }
        }
    },
}
const getSaleTransactionAbroadPackage = (name, id, price) => {
    let products = [
        {
            name,
            id,
            price,
            category: "Abroad",
            quantity: 1
        }
    ]
    return products;
}

const getSaleTransactionProducts = (saleType, selectedProducts, vasList, offerInfo) => {
    let products = [];

    // offerInfo
    if (offerInfo?.title) {
        products.push({
            id: offerInfo.title,
            name: offerInfo.title,
            category: saleType,
            price: offerInfo.basePrice,
            quantity: 1
        });
    }

    // selectedProducts
    const filteredSelectedProducts = _.chain(selectedProducts)
        .groupBy(x => [x.productMakat, x.additionalPrice])
        .map((value, key) => {
            return {
                id: key.split(',')[0],
                name: value[0].name,
                category: saleType,
                price: value.reduce((acc, x) => acc + x.additionalPrice, 0),
                quantity: value.length
            }
        })
        .value();

    if (filteredSelectedProducts.length > 0) {
        products = products.concat(filteredSelectedProducts);
    }


    // vasList
    let joinedVasList = [];

    if (vasList?.length > 0) {
        joinedVasList = [...joinedVasList, ...vasList];
    }

    const flattenSelectedVasListInProducts = selectedProducts?.reduce((acc, val) => acc.concat(val.selectedVasList), []);
    if (flattenSelectedVasListInProducts?.length > 0) {
        joinedVasList = [...joinedVasList, ...flattenSelectedVasListInProducts];
    }

    const filteredVasList = _.chain(joinedVasList)
        .groupBy(x => [x.socName, x.price])
        .map((value, key) => {
            return {
                id: key.split(',')[0],
                name: value[0].title,
                category: saleType,
                price: value.reduce((acc, x) => acc + x.price, 0),
                quantity: value.length
            }
        })
        .value();

    if (filteredVasList?.length > 0) {
        products = products.concat(filteredVasList);
    }

    return products;
}